module.exports = __webpack_public_path__ + "img/sv.5c1c802.png";